import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAllPublishers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cms/admin/blogpublishers')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

     
    createPublisher(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('cms/admin/publisher',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateblogpublisher(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put('cms/admin/publisher',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    


  },
}
